module.exports = __webpack_public_path__ + "static/Chris slaugh-7ff4b309355d71a37638f2ac20ef51ee.png";